// src/components/CardCourseSkeleton.jsx
import React from "react";
import SkeletonCard from "../../skeletons/SkeletonCard";

export const CardCourseSkeleton = () => {
  return (
    <div className="rounded-lg p-4 border border-gray-200 bg-white animate-pulse">
      {/* Header Skeleton */}
      <div className="mb-3 flex items-center gap-2">
        <div className="h-4 w-12 bg-gray-200 rounded-md"></div>
        <div className="h-4 w-8 bg-gray-200 rounded-md"></div>
      </div>

      {/* Title Skeleton */}
      <div className="rounded-md mb-3">
        <SkeletonCard
          type="text"
          lines={1}
          widths={["250px"]}
          heights={["20px"]}
        />
      </div>

      {/* Subtitle Skeleton */}
      <div className=" mt-4 mb-2">
        <SkeletonCard
          type="text"
          lines={1}
          widths={["200px"]}
          heights={["15px"]}
        />
      </div>

      {/* List Skeleton */}
      <ul className="list-disc list-inside mt-1 space-y-2 text-sm text-gray-500">
        <SkeletonCard
          type="text"
          lines={2}
          widths={["80px", "50px"]}
          heights={["10px", "10px"]}
        />
      </ul>
    </div>
  );
};
